import { render, staticRenderFns } from "./TenantEdit.vue?vue&type=template&id=c70a1e22&"
import script from "./TenantEdit.vue?vue&type=script&lang=js&"
export * from "./TenantEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports